"use strict";
(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[1020],{

/***/ 1020:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ cartNotification)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function cartNotification({ wrapper }) {
  const $wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper);

  const state = {
    items: []
  }

  const urls = {
    cartUpdate: '/cart/update.js',
    cartChange: '/cart/change.js',
    cartAdd: '/cart/add.js',
    cartGet: '/cart.json'
  }

  const settings = {
    slideCartInner: '[data-hook="cart-inner"]',
    closeCart: ".js-cart--close",
    openCart: "[data-toggle-cart]",
    checkoutButton: ".js-process-checkout",
    productForm: "form[action='/cart/add']",
    cartItem: '[data-hook="cart-item"]',
    cartCount: '[data-hook="cart-count"]',
    cartCountWrapper: '[data-hook="cart-count-wrapper"]',
  };

  (function init() {
    const sectionId = getCartSection();
    const wrapperSectionId = $wrapper.data('section-handle') || 'ajax-cart-notification';

    if (sectionId !== wrapperSectionId) return

    initializeEventListeners();
    buildCart();
  })();

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', closeCart)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('submit', settings.productForm, handleProductSubmit)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.closeCart, closeCart);
    $wrapper.on('click', settings.checkoutButton, processCheckout)

    if (location.pathname !== "/cart") {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.openCart, goToCart);
    }
  }

  function processCheckout(e) {
    location.href = "/checkout"
  }

  function getCookieValue(name) {
    const regex = new RegExp(`(^| )${name}=([^;]+)`)
    const match = document.cookie.match(regex)
    if (match) {
      return match[2]
    }
  }

  function trackAddItem(response) {
    // Needing to utilize the response object to pass
    // correct item params to Google Analytics 4
    gtag_report_conversion();
    ga4_report_conversion(response.items);
    klaviyo_report_atc(response.items);
  }

  function processCartRequest(data, endpoint, callback) {
    var params = {
      url: endpoint,
      data: data,
      method: 'POST',
      dataType: 'json',
      success: function (cart) {
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      },
      error: function (err) {
        console.warn(err)
      }
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(params).then(function (response) {
      if (endpoint === urls.cartAdd) {
        trackAddItem(response);
      }
    })
  }

  function formToJSON(f) {
    var fd = jquery__WEBPACK_IMPORTED_MODULE_0___default()(f).serializeArray();
    var d = {};

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(fd).each(function () {
      if (d[this.name] !== undefined) {
        if (!Array.isArray(d[this.name])) {
          d[this.name] = [d[this.name]];
        }
        d[this.name].push(this.value);
      } else {
        d[this.name] = this.value;
      }
    });
    return d;
  }

  function handleProductSubmit(e) {
    e.preventDefault()

    let data = formToJSON(this);

    const behavior = getCartBehavior();

    processCartRequest(data, urls.cartAdd, (response) => {
      const { items } = response;
      state.items = items;

      if (behavior === 'direct-to-cart') {
        window.location.href = '/cart'
      } else {
        buildCart()
        openCart()
        setTimeout(function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close')
        }, 4000)
      }
    })
  }

  function getCart(callback) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax({
      method: 'GET',
      url: urls.cartGet,
      dataType: 'json'
    }).then(callback);
  }

  function getCartSection() {
    return 'ajax-cart-notification';
    // let sectionId = 'ajax-cart-notification';

    // if (window.vwoTestNumber === "TEST") {
    //   sectionId = 'ajax-cart-notification';
    // }

    // if (window.vwoTestNumber) {
    //   const vwoTestCookie = getCookieValue(window.vwoTestNumber);
    //   sectionId = !!vwoTestCookie ? 'ajax-cart-notification' : 'ajax-cart';
    // } else {
    //   sectionId = 'ajax-cart-notification';
    // }

    // return sectionId
  }

  function getCartBehavior() {
    if (window.vwoTestNumber === "TEST") {
      return 'direct-to-cart'
    }

    const vwoTestCookie = getCookieValue(window.vwoTestNumber);
    if (window.vwoTestNumber && vwoTestCookie) {
      return 'direct-to-cart'
    } else {
      return 'open-cart'
    }
  }

  function buildCart() {
    getCart(function (cart) {
      const sectionID = getCartSection();
      let pathname = location.pathname === "/" ? "" : location.pathname;

      let activeElementId = document.activeElement.getAttribute('id');

      jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(`${pathname}/?sections=${sectionID}`)
        .then(function (response) {
          if (response[sectionID]) {
            let $response = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response[sectionID])
            let $newInnerHTML = $response.find(settings.slideCartInner)

            const $activeElement = $newInnerHTML.find(`#${activeElementId}`)

            state.items.forEach(item => {
              $newInnerHTML.find(`${settings.cartItem}[data-id="${item.id}"]`).addClass('on');
            })

            $wrapper.find(settings.slideCartInner).find('[data-cart-render]').each(function (index, oldItem) {
              const hook = jquery__WEBPACK_IMPORTED_MODULE_0___default()(oldItem).data('cart-render');
              const $newItem = $newInnerHTML.find(`[data-cart-render="${hook}"]`)

              jquery__WEBPACK_IMPORTED_MODULE_0___default()(oldItem).replaceWith($newItem)
            })

            $wrapper.toggleClass('empty', !cart.item_count);

            //update nav cart count
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartCount).text(cart.item_count)
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartCountWrapper).toggleClass('on', cart.item_count != 0);

            if ($activeElement.length) {
              $activeElement.trigger('focus');
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeCart).trigger('focus')
            }
          }
        })
        .catch(function (err) {
          console.warn(err);
        })
    })
  }

  function goToCart(e) {
    // cart notification. take to cart page
    if (e) e.preventDefault();
    window.location.href = '/cart'
  }

  function openCart() {
    if (location.pathname !== '/cart') {
      const $triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-toggle-cart]')
      $triggers.addClass('on')
      $wrapper.addClass('on')

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeCart).trigger('focus')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).addClass('overflow-hidden');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:show')
    }
  }


  function closeCart() {
    const $triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-toggle-cart]');
    $triggers.removeClass('on');

    $wrapper.removeClass('on')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).removeClass('overflow-hidden');
  }
}

/***/ })

}]);